import PropTypes from "prop-types";
import React from "react";

import SVGIcon from "common/SVGIcon";

import SummaryPosition from "./SummaryPosition";

const ApplicationSummarySubmits = ({ activePIDs, positions }) => {
    if (positions.length === 0) {
        return null;
    }

    const submitCount = positions.length;
    const s = submitCount > 1 ? "s" : "";

    const nodes = positions.map((p) => (
        <SummaryPosition key={p.id} position={p} activePIDs={activePIDs} />
    ));

    return (
        <div className="app-summary__section app-summary__section--content app-summary__submitted">
            <header className="app-summary__header">
                <SVGIcon icon="success-circle" />
                <h1>
                    You applied successfully &mdash; {submitCount} job{s}
                </h1>
            </header>
            <section className="app-summary__positions">{nodes}</section>

            <div className="app-summary__text">
                You&apos;ll get an email from us letting you know whether you&apos;ll move forward
                (usually within 48 hours, up to 10 days)
            </div>
        </div>
    );
};

ApplicationSummarySubmits.propTypes = {
    activePIDs: PropTypes.arrayOf(PropTypes.number).isRequired,
    positions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ApplicationSummarySubmits;
